import { render, staticRenderFns } from "./callStory.vue?vue&type=template&id=40b37992&"
import script from "./callStory.vue?vue&type=script&lang=js&"
export * from "./callStory.vue?vue&type=script&lang=js&"
import style0 from "./callStory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports